//
//
//
//
//
//
//

import { getCommonConfig } from '@/api/user';
export default {
  name: 'App',
  created: function created() {
    var _this = this;
    getCommonConfig().then(function (res) {
      _this.$store.dispatch('app/setCommonConfig', res);
    });
  }
};